/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';
import { BackendPatchedCapexRequestDto } from '../../models/backend-patched-capex-request-dto';

export interface EconomicIndicatorsCapexsPartialUpdate$Params {
  /**
   * A unique integer value identifying this capex.
   */
  id: number;
  body?: BackendPatchedCapexRequestDto;
}

export function economicIndicatorsCapexsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexDto>;
    }),
  );
}

economicIndicatorsCapexsPartialUpdate.PATH = '/api/economic_indicators/capexs/{id}/';
